module.exports = __webpack_public_path__ + "static/img/card.bee1fc49.png";